
export type Song = {
  title: string;
  destination: any;
  album?: string;
  items?: Song[];
  url?: string;
  track?: number;
};

export type FileDetail = {
  name: string;
  url: string;
  category?: string;
  songs?: Song[];
};

export type ErrorItem = {
  id?: number;
  name?: string;
  details?: string;
  message?: string;
  status?: number;
  missing?: boolean;
  stack?: string;
  time?: Date;
}

export const Categories = [
{
  name: 'game',
  icon: 'fasldr fa-gamepad'
},
{
  name: 'soundtrack',
  icon: 'fasldr fa-film'
},
{
  name: 'collection',
  icon: 'fasldr fa-compact-disc'
},
{
  name: 'conductor',
  icon: 'fasldr fa-circle-user'
},

]
